import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_MS_DARF_URL || 'http://localhost:5002',
});

export default api;